// extracted by mini-css-extract-plugin
export default {"Dashboard":"Dashboard_Dashboard__JhvwZ","header":"Dashboard_header__GZN2I","greeting":"Dashboard_greeting__D4lts","logout":"Dashboard_logout__Ca10y"};